import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import * as filters from './utils/filter'

import '@/assets/styles/reset.css'
import '@/assets/styles/theme.css'
import '@/assets/font-awesome/scss/font-awesome.scss'
import '@/assets/styles/common.sass'
// import { setCookie } from '@/utils/tools.js'

Vue.config.productionTip = false

Vue.use(ElementUI)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    correctImageUrl: (url, style) => {
      if (!url) return ''
      var pattern = new RegExp('[http|https]://')
      if (!url.match(pattern)) {
        url = 'http://overseas-1252412068.costj.myqcloud.com' + url
      }
      var cosPattern = new RegExp('1252412068')
      if (style && url.match(cosPattern)) {
        url = url.replace('1252412068.costj', '1252412068.pictj')
        url = url.replace('1252412068.cosca', '1252412068.picca')
        url = url + '/' + style
      }
      return url
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js